// @ts-nocheck
import { deleteRequest, get, patch, post } from './utils/api/index';
const API_URL = (process.env.REACT_APP_BASE_API_URL_SYNC || 'http://localhost:32768').trim();
const BASE_URL = new URL('/api/v1/configuracoes-listagem', API_URL).toString();
export const listarConfiguracoesListagem = async (rotaListagem) => {
    const response = await get(BASE_URL, {
        params: { rotaListagem },
        headers: {
            Accept: 'application/json'
        }
    });
    return response?.data || { registros: [] };
};
export const obterConfiguracaoListagemPadrao = async (rotaListagem) => {
    const response = await get(`${BASE_URL}/padrao`, {
        params: { rotaListagem },
        headers: {
            Accept: 'application/json'
        },
        validateStatus: (status) => status === 200 || status === 204
    });
    if (response?.status === 204) {
        return null;
    }
    return response?.data || null;
};
export const obterConfiguracaoListagemPorId = async (id) => {
    const response = await get(`${BASE_URL}/${id}`, {
        headers: {
            Accept: 'application/json'
        }
    });
    return response?.data || null;
};
export const criarConfiguracaoListagem = async (payload) => {
    const response = await post(BASE_URL, payload, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    });
    return response?.data || response;
};
export const excluirConfiguracaoListagem = async (id) => {
    await deleteRequest(`${BASE_URL}/${id}`);
};
export const atualizarConfiguracaoListagemPadrao = async (id, padrao) => {
    const response = await patch(`${BASE_URL}/${id}/padrao`, { padrao }, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    });
    return response?.data || response;
};
